import { useMutation } from '@tanstack/react-query';

import { assetsService } from '@/services/assets.service';
import { useStore } from '@/store/store';
import { downloadDocument } from '@/utils/download';

interface DownloadDocumentParams {
  assetId: string;
  filename: string;
  caseRecordId: string;
}

interface CaseRecordContext {
  organizationId: string;
  programId: string;
  caseRecordId: string;
}

export const useDownloadDocument = () => {
  const selectedOrganizationId = useStore(state => state.selectedOrganizationId);
  const selectedProgramId = useStore(state => state.selectedProgramId);

  const mutation = useMutation({
    mutationFn: async ({ assetId, caseRecordId, filename }: DownloadDocumentParams) => {
      const context: CaseRecordContext = {
        organizationId: selectedOrganizationId!,
        programId: selectedProgramId!,
        caseRecordId,
      };
      await downloadDocument(
        () => assetsService.downloadAssetFromArcus(context, assetId),
        filename,
      );
    },
  });

  return {
    downloadDoc: mutation.mutate,
    isDownloading: mutation.isPending,
  };
};
